<template>
  <tr class="invoice-table-row" :class="{ 'row-even': index % 2 === 1 }">
    <template v-for="col in columns">
      <!-- select -->
      <td
        v-if="col.value === 'data-table-select'"
        :key="'select-' + index"
        data-col="data-table-select"
        class="column-pin-cell"
      >
        <v-simple-checkbox
          :value="isSelected"
          :ripple="false"
          @input="$emit('toggle-select', $event)"
        />
      </td>

      <!-- actions -->
      <td
        v-else-if="col.value === 'actions'"
        :key="'actions-' + index"
        data-col="actions"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <v-menu offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn color="primary" v-bind="attrs" icon v-on="on">
              <v-icon medium> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-if="
                item.product &&
                costManagament &&
                (type == 'receipt' || type == 'tempReceipt')
              "
              link
              @click="$emit('open-cost-dialog', item)"
            >
              <v-list-item-icon>
                <v-icon> mdi-cash-minus </v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('cost')" />
            </v-list-item>
            <v-list-item
              v-if="costManagament && (type == 'receipt' || type == 'tempReceipt')"
              link
              @click="$emit('open-cost-list-dialog', item)"
            >
              <v-list-item-icon>
                <v-icon> mdi-format-list-bulleted-square </v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('costs')" />
            </v-list-item>
            <v-list-item
              v-if="rowHasSerial(item)"
              link
              @click="$emit('open-serial-dialog', item)"
            >
              <v-list-item-icon>
                <v-icon color="black" class="serial-barcode-icon">mdi-barcode</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('serial-management')" />
            </v-list-item>
            <v-list-item link @click="$emit('open-delete-dialog', item)">
              <v-list-item-icon>
                <v-icon color="pink"> mdi-trash-can-outline </v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('remove')" />
            </v-list-item>
          </v-list>
        </v-menu>
      </td>

      <!-- row -->
      <td
        v-else-if="col.value === 'row'"
        :key="'row-' + index"
        data-col="row"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        {{ rowNumber }}
      </td>

      <!-- product -->
      <td
        v-else-if="col.value === 'product'"
        :key="'product-' + index"
        data-col="product"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <autocomplete
          :ref="'refProduct' + itemIndex"
          v-model="item.product"
          :value="item.product"
          class=""
          :rules="[(v) => !!v || $t('is-required')]"
          type="product"
          :disabled="!entrepot"
          :new-btn="true"
          :new-style="true"
          :data="
            JSON.stringify({
              entrepot: entrepot ? entrepot.id : null,
              getCosts: type == 'warehouseHandling' ? true : false,
            })
          "
          :serial-btn="rowHasSerial(item)"
          @input="$emit('check-product', item, itemIndex)"
          @serial-click="$emit('open-serial-dialog', item)"
        />
      </td>

      <!-- to_product -->
      <td
        v-else-if="col.value === 'to_product'"
        :key="'to_product-' + index"
        data-col="to_product"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <autocomplete
          :ref="'refToProduct' + itemIndex"
          v-model="item.to_product"
          :value="item.to_product"
          class=""
          :rules="[(v) => !!v || $t('is-required')]"
          type="product"
          :disabled="!entrepot"
          :new-btn="true"
          :new-style="true"
        />
      </td>

      <!-- stock -->
      <td
        v-else-if="col.value === 'stock'"
        :key="'stock-' + index"
        data-col="stock"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        {{
          item.product && item.product.stock
            ? $numberFormat(item.product.stock.count, 3)
            : 0
        }}
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              color="error"
              overlap
              :content="item.cost.length"
              :value="item.cost.length"
            >
              <v-btn
                v-if="item.cost.length > 0"
                v-bind="attrs"
                color="cyan"
                x-small
                class="mx-1"
                v-on="on"
                @click="$emit('open-cost-list-dialog', item)"
              >
                {{ $t("costs") }}
              </v-btn>
            </v-badge>
          </template>
          <span>{{ $t("cost") }}</span>
        </v-tooltip>
      </td>

      <!-- unit -->
      <td
        v-else-if="col.value === 'unit'"
        :key="'unit-' + index"
        data-col="unit"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <v-select
          v-model="item.unit"
          :items="unitItems(item)"
          height="26"
          dense
          hide-details
          class="mb-3 input-new-style"
          outlined
          return-object
          item-value="id"
          item-text="fame"
          @change="$emit('change-unit', item)"
          :disabled="type == 'warehouseHandling' ? true : false"
        />
      </td>

      <!-- counting_one -->
      <td
        v-else-if="col.value === 'counting_one'"
        :key="'counting_one-' + index"
        data-col="counting_one"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <div class="d-flex">
          <v-text-field
            v-model="item.counting_one"
            height="20"
            dense
            solo
            flat
            hide-details
            :disabled="
              item.product &&
              item.product.units &&
              item.unit &&
              item.unit.id !== item.product.unit.id
            "
            class="mb-3 ms-1 dense custom input-new-style"
            :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
            :placeholder="$t('count')"
            type="number"
          />
        </div>
      </td>

      <!-- counting_two -->
      <td
        v-else-if="col.value === 'counting_two'"
        :key="'counting_two-' + index"
        data-col="counting_two"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <div class="d-flex">
          <v-text-field
            v-model="item.counting_two"
            height="20"
            dense
            solo
            flat
            hide-details
            :disabled="
              item.product &&
              item.product.units &&
              item.unit &&
              item.unit.id !== item.product.unit.id
            "
            class="mb-3 ms-1 dense custom input-new-style"
            :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
            :placeholder="$t('count')"
            type="number"
          />
        </div>
      </td>

      <!-- count -->
      <td
        v-else-if="col.value === 'count'"
        :key="'count-' + index"
        data-col="count"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <div class="d-flex">
          <v-text-field
            v-show="
              item.product &&
              item.product.units &&
              item.unit &&
              item.unit.id !== item.product.unit.id
            "
            v-model="item.countUnit"
            height="20"
            dense
            solo
            flat
            hide-details
            class="mb-3 dense custom input-new-style"
            :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
            :placeholder="$t('count')"
            type="number"
            @input="$emit('convert-unit', item)"
          />
          <v-text-field
            v-model="item.count"
            height="20"
            dense
            solo
            flat
            hide-details
            :disabled="
              item.product &&
              item.product.units &&
              item.unit &&
              item.unit.id !== item.product.unit.id
            "
            class="mb-3 ms-1 dense custom input-new-style"
            :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
            :placeholder="$t('count')"
            type="number"
            @input="$emit('check-count', item)"
          />
        </div>
      </td>

      <!-- price -->
      <td
        v-else-if="col.value === 'price'"
        :key="'price-' + index"
        data-col="price"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <money
          v-model="item.price"
          :dense="true"
          :outlined="true"
          :rules="[feeValidate]"
          :solo="false"
          :new-style="true"
          :clearable="true"
          value-when-is-empty=""
          :options="options"
          class="mb-3 dense"
        />
      </td>

      <!-- expire_date -->
      <td
        v-else-if="col.value === 'expire_date'"
        :key="'expire_date-' + index"
        data-col="expire_date"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <v-text-field
          :id="'expireDate' + index"
          v-model="item.expire_date"
          clear-icon="flaticon2-close-cross"
          outlined
          dense
          hide-details
          height="25"
          class="mb-3 input-new-style"
          :disabled="type !== 'receipt'"
          clearable
        />
        <date-picker
          v-model="item.expire_date"
          :element="'expireDate' + index"
          :locale="$store.state.date_locale"
          :format="$store.state.date_format"
          auto-submit
          :color="
            $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
          "
        />
      </td>

      <!-- content -->
      <td
        v-else-if="col.value === 'content'"
        :key="'content-' + index"
        data-col="content"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <v-text-field
          v-model="item.content"
          height="20"
          dense
          solo
          flat
          hide-details
          class="mb-3 dense input-new-style"
          :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
          clearable
          :placeholder="$t('content')"
        />
      </td>

      <!-- entrepot -->
      <td
        v-else-if="col.value === 'entrepot'"
        :key="'entrepot-' + index"
        data-col="entrepot"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      >
        <autocomplete
          v-model="item.article_entrepot"
          class=""
          type="entrepot"
          :new-style="true"
          @input="$emit('change-entrepot', item, index)"
        />
      </td>

      <!-- fallback for any other header column -->
      <td
        v-else
        :key="col.value + '-' + index"
        :data-col="col.value"
        class="column-pin-cell"
        :class="{ 'is-sticky': isStickyColumn(col) }"
        :style="cellStickyStyle(col)"
      />
    </template>
  </tr>
</template>

<script>
import autocomplete from "../../../components/general/patial/autocomplete";
import Money from "../../../components/general/Money/index";
import { getStickyStyleForColumn } from "@/plugins/columnPin/columnPin";

export default {
  name: "EntrepotTableRow",
  components: {
    autocomplete,
    Money,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
    rowNumber: {
      type: [Number, String],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    entrepot: {
      default: null,
    },
    costManagament: {
      default: null,
    },
    options: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      },
    },
    lockedColumns: {
      type: Array,
      default: function () {
        return ["actions", "row", "product"];
      },
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRtl() {
      return !!(this.$vuetify && this.$vuetify.rtl);
    },
  },
  methods: {
    isStickyColumn(col) {
      if (!col) return false;
      return this.lockedColumns.indexOf(col.value) !== -1 || !!col.pinned;
    },
    cellStickyStyle(col) {
      if (!col || !this.isStickyColumn(col)) return null;
      return getStickyStyleForColumn(
        this.columns,
        col.value,
        this.lockedColumns,
        this.isRtl
      );
    },
    unitItems(item) {
      if (item.product) {
        var units = [item.product.unit];
        if (item.product.units) {
          item.product.units.map(function (value, index) {
            value.unit.value = value.value;
            units.push(value.unit);
          });
        }
        if (!item.unit) {
          item.unit = item.product.unit;
        }
        return units;
      } else {
        return [];
      }
    },
    getProductHasSerial(product) {
      if (!product) return false;
      const flag = (product.meta && product.meta.has_serial) || product.has_serial;
      return flag === "active";
    },
    rowHasSerial(item) {
      return !!(
        item &&
        (item.has_serial === "active" || this.getProductHasSerial(item.product))
      );
    },
  },
};
</script>

<style scoped>
.invoice-table-row {
  height: 30px !important;
}
.invoice-table-row.row-even {
  background: #fff;
}
.invoice-table-row:not(.row-even) {
  background: #f5f5f5;
}
.invoice-table-row >>> td {
  padding: 4px 4px !important;
  vertical-align: middle !important;
  font-size: 12px !important;
}
.invoice-table-row.row-even >>> td {
  background: #fff !important;
}
.invoice-table-row:not(.row-even) >>> td {
  background: #f5f5f5 !important;
}
.invoice-table-row >>> td.is-sticky {
  position: sticky;
  border-top: none !important;
  overflow: hidden !important;
}
.invoice-table-row.row-even >>> td.is-sticky {
  background: #fff !important;
}
.invoice-table-row:not(.row-even) >>> td.is-sticky {
  background: #f5f5f5 !important;
}
.invoice-table-row >>> td[data-col="product"].is-sticky {
  border-left: 1px solid #e0e0e0;
}
.invoice-table-row >>> .v-input,
.invoice-table-row >>> .v-text-field,
.invoice-table-row >>> .v-select {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center;
}
.invoice-table-row >>> td > .v-input,
.invoice-table-row >>> td > .d-flex {
  display: flex !important;
  align-items: center !important;
  width: 100%;
  gap: 0;
}
.invoice-table-row >>> td > .d-flex > div {
  flex: 1 1 auto;
  min-width: 0;
}
.invoice-table-row >>> .v-btn.v-btn--icon {
  width: 28px !important;
  height: 28px !important;
}
.invoice-table-row >>> .v-btn.v-btn--icon .v-icon {
  font-size: 18px !important;
}
.invoice-table-row >>> .v-input {
  font-size: 12px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.invoice-table-row >>> .mb-3,
.invoice-table-row >>> .mb-2 {
  margin-bottom: 0 !important;
}
.invoice-table-row >>> .v-text-field,
.invoice-table-row >>> .v-select {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.invoice-table-row >>> .v-text-field--outlined .v-input__control,
.invoice-table-row >>> .v-text-field--outlined .v-input__slot,
.invoice-table-row >>> .v-select.v-text-field--outlined .v-input__control,
.invoice-table-row >>> .v-select.v-text-field--outlined .v-input__slot,
.invoice-table-row >>> .v-text-field--solo .v-input__control,
.invoice-table-row >>> .v-text-field--solo .v-input__slot {
  min-height: 26px !important;
  height: 26px !important;
}
.invoice-table-row >>> .v-select.v-text-field--outlined .v-input__slot {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.invoice-table-row >>> td[data-col="count"] {
  padding-left: 2px !important;
  padding-right: 2px !important;
}
.invoice-table-row
  >>> .v-text-field--outlined.v-input--dense
  > .v-input__control
  > .v-input__slot,
.invoice-table-row >>> .v-select.v-input--dense > .v-input__control > .v-input__slot,
.invoice-table-row
  >>> .v-text-field--solo.v-input--dense
  > .v-input__control
  > .v-input__slot {
  min-height: 26px !important;
  height: 26px !important;
}
.invoice-table-row >>> .v-text-field--outlined fieldset {
  top: -3px;
  border-radius: 3px;
}
.invoice-table-row >>> input,
.invoice-table-row >>> .v-select__selection,
.invoice-table-row >>> .v-select__selections {
  font-size: 12px !important;
  line-height: 18px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  max-height: 26px;
  margin: 0 !important;
}
.invoice-table-row >>> .v-label {
  font-size: 11px !important;
}
.invoice-table-row >>> .v-input__append-inner,
.invoice-table-row >>> .v-input__prepend-inner,
.invoice-table-row >>> .v-input__append-outer,
.invoice-table-row >>> .v-input__prepend-outer {
  display: flex !important;
  align-items: center !important;
  align-self: center !important;
  height: 26px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-table-row >>> .v-input__append-outer {
  margin: 0 !important;
  padding: 0 !important;
  width: 0 !important;
  min-width: 0 !important;
  overflow: hidden !important;
}
.invoice-table-row >>> .v-input__append-inner {
  margin: 0 !important;
  padding: 0 !important;
  min-width: 0 !important;
}
.invoice-table-row >>> .v-input__append-inner .v-btn,
.invoice-table-row >>> .v-input__prepend-inner .v-btn,
.invoice-table-row >>> .v-input__append-outer .v-btn,
.invoice-table-row >>> .v-input__prepend-outer .v-btn,
.invoice-table-row >>> .v-input__append-inner .v-icon,
.invoice-table-row >>> .v-input__prepend-inner .v-icon,
.invoice-table-row >>> .v-input__append-outer .v-icon,
.invoice-table-row >>> .v-input__prepend-outer .v-icon {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
}
.invoice-table-row >>> .v-icon {
  font-size: 15px !important;
  height: 15px !important;
  width: 15px !important;
}
.invoice-table-row >>> .v-text-field__details,
.invoice-table-row >>> .v-messages {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}
.invoice-table-row >>> .v-input__slot {
  box-shadow: none !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.invoice-table-row >>> .v-input__control {
  min-height: 26px !important;
}
.invoice-table-row >>> .v-input--dense .v-input__slot,
.invoice-table-row >>> .v-text-field.v-text-field--enclosed .v-input__slot {
  margin-bottom: 0 !important;
}
.invoice-table-row >>> .v-input,
.invoice-table-row >>> .v-input > .v-input__control {
  align-self: center !important;
}
.input-new-style ::v-deep .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
}
.input-new-style ::v-deep fieldset {
  border: none !important;
}
.input-new-style ::v-deep .v-input__slot::before,
.input-new-style ::v-deep .v-input__slot::after {
  display: none !important;
}
::v-deep .custom .v-input__control .v-input__slot .v-text-field__slot input {
  width: 50px;
}
.serial-barcode-icon {
  transform: rotate(90deg);
  transform-origin: center center;
}
</style>
